(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["truelove-coupon"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-tl-coupon-expiry]').forEach(function(banner){var deadline=Date.parse(banner.dataset.tlCouponExpiry);function expire(){if(Date.now()>=deadline){banner.remove();}}expire();var remaining=deadline-Date.now();if(remaining>0&&remaining<2147483647){setTimeout(expire,remaining);}});

if (!window.trueloveCouponFeedbackReady) {
  window.trueloveCouponFeedbackReady = true;
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-tl-coupon-apply]');
    if (!button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    const banner = button.closest('[data-tl-coupon-code]');
    if (!banner) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;
    const status = banner.querySelector('[data-tl-coupon-status]');
    const initialLabel = button.textContent;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    const code = banner.dataset.tlCouponCode;
    const isCode = value => String(value || '').toUpperCase() === code;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    button.textContent = banner.dataset.pending;
    status.hidden = false;
    status.textContent = banner.dataset.pending;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({discount: code}),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Coupon request failed');
      const cart = await response.json();
      if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
      const allocations = [
        ...(cart.cart_level_discount_applications || []),
        ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(allocation => ({
          ...allocation.discount_application, total_allocated_amount: allocation.amount
        })))
      ];
      const applied = allocations.some(discount => isCode(discount.title) && Number(discount.total_allocated_amount) > 0);
      const hasTarget = cart.items.some(item => ['tls4862','tls48622'].includes(item.handle));
      status.textContent = applied ? banner.dataset.applied : hasTarget ? banner.dataset.unconfirmed : banner.dataset.saved;
      button.textContent = applied ? banner.dataset.appliedButton : banner.dataset.savedButton;
    } catch (error) {
      status.textContent = banner.dataset.error;
      button.textContent = initialLabel;
    } finally {
      clearTimeout(timeout);
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
